import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import searchClient from 'bl/client/searchClient.bl';
import { withTranslation } from 'providers/GILT.provider';
import { selectHideDetails } from 'selectors/user';
import fromStringToXs from 'utils/converters/fromStringToXs';
import fromAnyToInitials from 'utils/converters/string/fromAnyToInitials.util';

import ClientItem from 'scheduler/components/ClientItem';

const SearchableDropdown = ({ type, placeholder, list, pickClient, t, history, location, hideDetails }) => {
  const [searchText, setSearchText] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const addNewClient = () => {
    const pathArray = history.location.pathname.split('/');
    let newPath = location.pathname;

    if (pathArray[3] === 'day') {
      newPath = pathArray.slice(0, 5).join('/');
    } else if (pathArray[3] === 'week') {
      newPath = pathArray.slice(0, 6).join('/');
    }

    const escapedSearchText = searchText.replace('/', '');

    if (searchText.length > 0) {
      history.push(`${newPath}/appointment/new/create/${escapedSearchText}/client`);
    } else {
      history.push(`${newPath}/appointment/new/client`);
    }
  };

  const pickWalkIn = () => {
    pickClient('walkIn');
    history.push('services');
  };

  const resultList = searchClient({ text: searchText, list });

  const btnStyle = {
    paddingTop: '20px',
    textAlign: 'center',
  };

  return (
    <div data-bem="SearchableDropdown" className="searchable-container">
      <div className="space">
        <input
          ref={inputRef}
          className="input-default search-dropdown"
          type={type}
          placeholder={placeholder}
          value={searchText.replace(/\s{2,}/g, ' ')}
          onChange={(e) => {
            setSearchText(e.target.value.toLowerCase());
          }}
        />
      </div>

      <div style={btnStyle}>
        <div className="btn btn-violet-link f-b text-upper" onClick={addNewClient} role="button" tabIndex="0">
          {t('scheduler.booking.addNewClient')}
        </div>

        <div className="btn btn-violet-link f-b text-upper" onClick={pickWalkIn} role="button" tabIndex="0">
          {t('scheduler.booking.walkIn')}
        </div>
      </div>

      {searchText.length >= 2 && (
        <div className="search-dropdown-results find-client in-booking">
          {resultList.length > 0 ? (
            resultList.map((o) => (
              <ClientItem
                key={o.id}
                onClick={() => pickClient(o)}
                initials={fromAnyToInitials(o.user_name)}
                known_as={o.known_as ? o.known_as : ''}
                phone={o.phone}
                notes={o.notes ? t('scheduler.booking.notes', { notes: o.notes }) : ''}
                rank={o.rank}
                user_name={o.user_name}
              >
                {hideDetails ? <td>{o.phone && fromStringToXs(o.phone)}</td> : <td>{o.phone}</td>}
              </ClientItem>
            ))
          ) : (
            <div />
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  hideDetails: selectHideDetails(state),
});

const SearchableDropdownHoc = connect(mapStateToProps)(withTranslation()(SearchableDropdown));

export default SearchableDropdownHoc;
